import { render, staticRenderFns } from "./create-project-dialog.vue?vue&type=template&id=f7128e9a&scoped=true"
import script from "./create-project-dialog.ts?vue&type=script&lang=js&external"
export * from "./create-project-dialog.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7128e9a",
  null
  
)

export default component.exports